import { render, staticRenderFns } from "./ToateRepartizate.vue?vue&type=template&id=2d6d948b&scoped=true&"
import script from "./ToateRepartizate.ts?vue&type=script&lang=ts&"
export * from "./ToateRepartizate.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d948b",
  null
  
)

export default component.exports
import {QSelect,QInput,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QSelect,QInput,QPopupProxy,QDate,QIcon,QBtn,QSpinnerGears,QDialog,QCard,QCardSection}, component.options.components || {})
